"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@jsluna/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Error = function Error(_ref) {
  var className = _ref.className,
      message = _ref.message;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: ("ln-u-display-flex ln-u-align-items-center " + className).trim()
  }, /*#__PURE__*/_react.default.createElement(_icons.ErrorCircle, {
    className: "ln-u-color-red ln-u-margin-right",
    size: "large"
  }), message || 'An error has occurred!');
};

Error.propTypes = {
  className: _propTypes.default.string,
  message: _propTypes.default.string
};
Error.defaultProps = {
  className: '',
  message: ''
};
var _default = Error;
exports.default = _default;